import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BoldPipe } from '@app/pipe/bold.pipe';
import { SafeHtmlPipe } from '@app/pipe/safe-html.pipe';
import { SearchPipe } from '@app/pipe/search.pipe';

export const pipes = [
  BoldPipe,
  SafeHtmlPipe,
  SearchPipe
]

@NgModule({
  imports: [CommonModule],
  declarations: [...pipes],
  exports: [...pipes],
})
export class PipesModule { }